import React from 'react';

/**
 * QUOD-Finder™ brand mark.
 *
 * Renders the single approved brand asset. The ™ mark and the
 * "Powered by QUOD-TECH" sub-line are baked into the asset itself,
 * so this component no longer overlays any separate TM badge.
 *
 * Use this everywhere the QUOD-Finder brand appears — header, auth
 * screens, invite-accept, splash/loading, and future footer /
 * branding sections.
 *
 * Props
 * ─────
 *   variant        'header' | 'auth' | 'inline'. Drives the CSS
 *                  sizing modifier on the wrapper span. Default
 *                  'inline'.
 *   alt            <img> alt text. Default 'QUOD-Finder™'.
 *   imgClassName   Optional extra class on the <img> (legacy layout
 *                  hooks such as `.app-header-logo` / `.auth-logo`).
 *   className      Optional extra class on the wrapper span.
 *   onClick        Optional click handler on the wrapper.
 *   'data-testid'  Optional — forwarded to the <img> for tests.
 */
export default function Logo({
  variant = 'inline',
  alt = 'QUOD-Finder\u2122',
  imgClassName = '',
  className = '',
  onClick,
  'data-testid': testId,
  ...rest
}) {
  const variantClass =
    variant === 'header' ? 'brand-logo--header'
    : variant === 'auth' ? 'brand-logo--auth'
    : 'brand-logo--inline';

  return (
    <span
      className={`brand-logo ${variantClass} ${className}`.trim()}
      onClick={onClick}
      {...rest}
    >
      <img
        src="/quod-finder-logo.png"
        alt={alt}
        className={`brand-logo-img ${imgClassName}`.trim()}
        draggable={false}
        data-testid={testId}
      />
    </span>
  );
}
